import React, { ButtonHTMLAttributes, useEffect, useState } from 'react';
import GoogleLogo from './googleLogo.svg?url';

import './LoginWithGoogleButton.css';

type LoginWithGoogleButtonProps = {
  onClick: ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
  hasError?: boolean;
};

export const LoginWithGoogleButton = ({
  onClick,
  hasError,
}: LoginWithGoogleButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (hasError) {
      setIsLoading(false);
    }
  }, [hasError]);

  const handleClick: ButtonHTMLAttributes<HTMLButtonElement>['onClick'] = e => {
    setIsLoading(true);
    onClick?.(e);
  };

  return (
    <button
      onClick={handleClick}
      disabled={isLoading}
      data-content={isLoading ? 'Redirecting...' : 'Login with Google'}
      className={`login-google-button${isLoading ? ' login-google-button--loading' : ''}`}>
      <img src={GoogleLogo} width={30} height={30} alt="google logo"></img>
      <span
        style={{
          position: 'absolute',
          left: '-100vw',
          visibility: 'hidden',
        }}>
        Log in with Google
      </span>
    </button>
  );
};
